var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Objeto/Identificadores",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 1;
      }
    }
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "objeto"
    }
  }, [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "state": _vm.validateClienteState('objeto'),
      "options": _vm.objetos,
      "clearSearchOnSelect": true
    },
    on: {
      "open": _vm.onSearchObjetos,
      "search": _vm.onSearchObjetos,
      "input": _vm.setObjeto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.objeto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "objeto", $$v);
      },
      expression: "form.objeto"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do objeto ")])], 2)], 1)], 1), _c('b-col', [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newObjectModal",
      modifiers: {
        "newObjectModal": true
      }
    }],
    staticClass: "btn btn-primary font-weight-bold"
  }, [_vm._v(" Novo ")])])], 1), _vm.identificadores.length > 0 ? _c('b-row', _vm._l(_vm.identificadores, function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": identificador.descricao
      }
    }, [_c('b-form-input', {
      attrs: {
        "maxLength": "30",
        "placeholder": _vm.placeholderIdentificador(identificador),
        "value": _vm.identificadoresFilled[identificador.descricao]
      },
      on: {
        "input": function input(value) {
          return _vm.changeValues(identificador.descricao, value);
        }
      }
    })], 1)], 1);
  }), 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "newObjectModal",
      "centered": "",
      "title": "Cadastrar novo objeto"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.openModal = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "saveNewObject",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.saveNewObject
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "autofocus": ""
    },
    model: {
      value: _vm.newObjetoDescricao,
      callback: function callback($$v) {
        _vm.newObjetoDescricao = $$v;
      },
      expression: "newObjetoDescricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cliente",
      "label-for": "cliente",
      "label": "Cliente"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "placeholder": "Informe o nome do cliente",
      "label": "id_pessoa",
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CNPJ/CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.valueCliente,
      callback: function callback($$v) {
        _vm.valueCliente = $$v;
      },
      expression: "valueCliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.identificadores.length > 0 ? _c('b-row', _vm._l(_vm.identificadores, function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": identificador.descricao
      }
    }, [_c('b-form-input', {
      attrs: {
        "maxLength": "30",
        "placeholder": _vm.placeholderIdentificador(identificador),
        "value": _vm.newObjectIdentificadoresFilled[identificador.descricao]
      },
      on: {
        "input": function input(value) {
          return _vm.newObjectChangeValues(identificador.descricao, value);
        }
      }
    })], 1)], 1);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };